import { ADD_CREDENTIALS, SET_AUTH_STATUS, DO_LOGOUT } from "./constants";

export const addCredentials = auth => ({ type: ADD_CREDENTIALS, payload: auth });
export const setAuthStatus = status => ({ type: SET_AUTH_STATUS, payload: status });
export const doLogout = auth => ({ type: DO_LOGOUT, payload: auth });


// WEBPACK FOOTER //
// ./src/store/actions/auth.js